import React from 'react';
import Typography from '@material-ui/core/Typography';

export const ArrayToStringField = ({ className,
    source,
    record = {},
    ...rest}) => (

        <Typography
            component="span"
            variant="body2"
            className={className}
            {...rest}
        >
            {record[source].join(", ")}
        </Typography>
)
ArrayToStringField.defaultProps = { addLabel: true};
